import React from 'react';
import styles from './SupportContact.module.scss';
import {Image} from "../../../../../../../components";
import telephone from "../../../../../../../assets/images/svg/telephone.svg";
import mail from "../../../../../../../assets/images/svg/mail.svg";
import clock from "../../../../../../../assets/images/svg/clock.svg";
import apiClientConfig from "../../../../../../../configs/app";

const SupportContact = () => {
  return (
    <div className={styles.supportContent}>
      <span className={styles.supportTitle}>Служба поддержки</span>
      <div className={styles.contactItem}>
        <Image src={telephone} alt={'telephone'} className={styles.contactIcon}/>
        <a href="tel:+74951501667" className={styles.contactLink}>
              +7 (495) 150-16-67
        </a>
      </div>

      <div className={styles.contactItem}>
        <Image src={mail} alt={'mail'} className={styles.contactIcon}/>
        <a href="mailto:" className={styles.contactLink}>
          {apiClientConfig.email}
        </a>
      </div>

      <div className={styles.contactItem}>
        <Image src={clock} alt={'clock'} className={styles.contactIcon}/>
        <span className={styles.contactText}>с 9:00 до 19:00</span>
      </div>
      <div className={styles.description}>
        Если у Вас имеются вопросы или Вам нужна  помощь в заполнении верификационной анкеты, Вы можете обратиться  в клиентскую службу поддержки платформы “Кономика-займы” по следующим контактным данным
      </div>
    </div>
  );
};

export default SupportContact;

